<mat-paginator *ngIf="displayPaginator" #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
<table mat-table matSort [dataSource]="dataSource" style="width:100%;">
    <ng-container *ngFor="let field of fields" matColumnDef="{{field}}">
        <th mat-header-cell *matHeaderCellDef><div *ngIf="cell"> {{field}} </div></th>
        <td mat-cell *matCellDef="let item; let itemindex = index">
            <app-snitem-table-row [item]="item" [component]="row"></app-snitem-table-row>
        </td>
    </ng-container>
    <tr [ngClass]="{'hide-header' : !cell}" mat-header-row *matHeaderRowDef="fields"></tr>
    <tr mat-row *matRowDef="let row; columns: fields;"></tr>
</table>
